import React, { createContext, useState, useEffect, useContext } from 'react';

// Create language context
export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Set default language - Russian
  const [currentLanguage, setCurrentLanguage] = useState('ru');
  
  // Get saved language from localStorage on initialization
  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    } else {
      // If no saved language, set Russian as default
      localStorage.setItem('language', 'ru');
    }
  }, []);
  
  // Function to change language
  const changeLanguage = (langCode) => {
    setCurrentLanguage(langCode);
    localStorage.setItem('language', langCode);
    
    // You can add any additional logic needed when language changes
    // For example, update document lang attribute
    document.documentElement.lang = langCode;
  };
  
  return (
    <LanguageContext.Provider value={{ currentLanguage, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook to use language in components
export const useLanguage = () => useContext(LanguageContext); 